declare var window: any;

const UpdateAlert = {
  mounted(this: any) {
    const handleUpdateAlert = ({ type, message }: any) => {
      var event = new CustomEvent("flash", {
        detail: { type: type, message: message },
      });
      window.dispatchEvent(event);
    };
    this.handleEvent("update_alert", handleUpdateAlert);
  },
};

export default UpdateAlert;
